import React from 'react';
import { useTranslation } from 'react-i18next';

import { BottomButtonsWrapperPropTypes } from 'src/components/JobSpellCheckPopup/propTypes';
import s from 'src/components/JobSpellCheckPopup/JobSpellCheckPopup.styles';

export const BottomButtonsWrapper = ({
  ignoreButtonsDisabled,
  onIgnore,
  onIgnoreAll,
  onReplace,
  onReplaceAll,
  replaceButtonsDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <s.ActionButtonsWrapper>
        <div>
        <s.ActionButton
          disabled={replaceButtonsDisabled}
          onClick={onReplace}
          orange
          outline
          sm
        >
          {t('REPLACE')}
        </s.ActionButton>
        <s.ActionButton
          disabled={replaceButtonsDisabled}
          onClick={onReplaceAll}
          sm
          title={t('REPLACE_ALL_BUTTON_TOOLTIP')}
        >
          {t('REPLACE_ALL')}
        </s.ActionButton>
      </div>
      <div>
        <s.ActionButton
          disabled={ignoreButtonsDisabled}
          onClick={onIgnore}
          orange
          outline
          sm
        >
          {t('IGNORE')}
        </s.ActionButton>
        <s.ActionButton
          disabled={ignoreButtonsDisabled}
          onClick={onIgnoreAll}
          sm
          title={t('IGNORE_ALL_BUTTON_TOOLTIP')}
        >
          {t('IGNORE_ALL')}
        </s.ActionButton>
      </div>
    </s.ActionButtonsWrapper>
  );
};

BottomButtonsWrapper.propTypes = BottomButtonsWrapperPropTypes;
